import { twMerge } from 'tailwind-merge';

import { USStateObject } from '@domain/states/types';
import { getFishingWaterUrl, getRegionUrl } from '@domain/routes/urls';
import { InternalLink } from '../../Clickables/InternalLink/InternalLink';
import { ArrowRightIcon } from '../../Icons/ArrowRightIcon';
import { Text } from '../../Text/Text';
import { IStateDataWatersList } from '../helpers/buildStateDataWaters';

interface IProps {
  selectedState: USStateObject;
  stateWatersList?: IStateDataWatersList;
  className: string;
}

/*
NB: These waters have been exported by the BI team directly from our production database and so
these links will not work on staging!
*/
export const StateLinks = ({ selectedState, className, stateWatersList }: IProps) => {
  const countryId = 'US';
  const countryName = 'United States';
  const orderedWaters = stateWatersList
    ? [...stateWatersList.stateWaterList].sort(
        (a, b) => Number(a.state_rank) - Number(b.state_rank),
      )
    : [];
  const headingText = `Popular fishing spots in ${selectedState.stateName}`;
  const buttonText = `Explore ${selectedState.stateName}`;
  return (
    <div className={twMerge('mx-auto w-full flex-col gap-y-3 sm:w-1/2', className)}>
      <Text variant="sm" className="mb-0">
        {headingText}
      </Text>
      <div className="flex flex-col gap-y-3">
        {orderedWaters.map(water => {
          const name = water.water_name;
          const externalId = water.external_id;
          return (
            <InternalLink
              to={getFishingWaterUrl(externalId, name)}
              key={`StateLinks-${water.external_id}`}
            >
              <Text variant="md" className="mb-0 py-1">
                {water.water_name}
                <ArrowRightIcon size={18} className="ml-1" />
              </Text>
            </InternalLink>
          );
        })}
      </div>
      <div className="flex w-full justify-center sm:justify-start">
        <InternalLink
          to={getRegionUrl(countryId, selectedState.stateID, countryName, selectedState.stateName)}
          variant="buttonSecondary"
        >
          {buttonText}
        </InternalLink>
      </div>
    </div>
  );
};
